import React, { Component } from 'react';
import * as styled from '../../../styles/style';

class Collapsible extends Component {
  constructor() {
    super();
    this.state = {
      open: false
    }
  }

  handleClick = (event) => {
    event.preventDefault();
    this.setState({
      open: !this.state.open
    })
  }

  render() {
    let classes = 'collapsible';
    if (this.props.containerClasses) { classes = `${classes} ${this.props.containerClasses}` }

    return (
      <div className={classes}>
        <a onClick={this.handleClick} style={{display: 'inline-block', margin: '0 0 20px 20px'}} href="#" className="collapsible-link">{this.props.linkText}</a>
        {this.state.open && (
          <div className="collapsible-content" style={{marginLeft: '15px'}}>
            {this.props.children}
          </div>
        )}
      </div>
    )
  }
}

export default Collapsible
